import weteacheManage from "../../layout/weteacheManage"
// 注意路由格式前缀一定要加/teacheManage
export default {
    path: "/teacheManageIndex/index",
    component: weteacheManage,
    redirect: "/teacheManage/dashboard",
    alwaysShow: true,
    name: "teacheManageIndex",
    children: [
        {
            path: "/teacheManage/dashboard",
            name: "dashboard",
            meta: {
                parent:{
					path:'/teacheManage/dashboard',
					title:'控制中心',
					mosttitle:'控制中心'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'控制中心',index:0
            },
            component: () => import("@/weteacheManage/dashboard/index")  
        },
		{
            path: "/teacheManage/appControl",
            name: "appControl",
            meta: {
                parent:{
					path:'/teacheManage/appControl',
					title:'我的应用',
					mosttitle:'我的应用'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'我的应用',index:1
            },
            component: () => import("@/weteacheManage/appControl/index")  
        },{
            path: "/teacheManage/appLog",
            name: "appLog",
            meta: {
                parent:{
					path:'/teacheManage/appControl',
					title:'我的应用',
					mosttitle:'我的应用'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'应用日志',index:1
            },
            component: () => import("@/weteacheManage/appControl/appLog")  
        },
		{
            path: "/teacheManage/alarmRule",
            name: "tealarmRule",
            meta: {
                parent:{
					path:'/teacheManage/alarmRule',
					title:'我的应用',
					mosttitle:'我的应用'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'仿真报警规则',index:1
            },
            component: () => import("@/weteacheManage/appControl/alarmRule")  
        },{
            path: "/teacheManage/alarmType",
            name: "tealarmType",
            meta: {
                parent:{
					path:'/teacheManage/alarmType',
					title:'我的应用',
					mosttitle:'我的应用'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'仿真报警分类',index:1
            },
            component: () => import("@/weteacheManage/appControl/alarmType")  
        },
		,
		{
			path: "/teacheManage/addAlarm",
			name: "teaddAlarm",
			meta: {
				parent:{
					path:'/teacheManage/alarmRule',
					title:'我的应用',
					mosttitle:'添加报警规则',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'添加报警规则',index:1
			},
			component: () => import("@/weteacheManage/appControl/addAlarm")  
		},
        {
            path: "/teacheManage/member",
            name: "member",
            meta: {
                parent:{
					path:'/teacheManage/member',
					title:'成员管理',
					mosttitle:'成员列表'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'成员列表',index:5
            },
            component: () => import("@/weteacheManage/member/memberList/index")  
        },
        {
			path: "/teacheManage/editMember",
			name: "editMember",
			meta: {
				parent:{
					path:'/teacheManage/member',
					title:'成员管理',
					mosttitle:'成员列表',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'编辑成员',index:5
			},
			component: () => import("@/weteacheManage/member/memberList/editMember/index")
		},
        {
            path: "/teacheManage/role",
            name: "role",
            meta: {
                parent:{
					path:'/teacheManage/role',
					title:'成员管理',
					mosttitle:'角色列表'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'角色列表',index:5
            },
            component: () => import("@/weteacheManage/member/role/index")  
        },{
            path: "/teacheManage/studentClass",
            name: "studentClass",
            meta: {
                parent:{
					path:'/teacheManage/studentClass',
					title:'成员管理',
					mosttitle:'学员分类'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'学员分类',index:5
            },
            component: () => import("@/weteacheManage/member/studentClass/index")  
        },{
            path: "/teacheManage/studentList",
            name: "studentList",
            meta: {
                parent:{
					path:'/teacheManage/studentList',
					title:'成员管理',
					mosttitle:'学员列表'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'学员列表',index:5
            },
            component: () => import("@/weteacheManage/member/studentList/index")  
        },{
			path: "/teacheManage/studentDetail",
			name: "studentDetail",
			meta: {
				parent:{
					path:'/teacheManage/studentList',
					title:'学员列表',
					mosttitle:'成员管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'学员详情',index:5
			},
			component: () => import("@/weteacheManage/member/studentList/studentDetail/index")
		},
		{
            path: "/teacheManage/enTestPaper",
            name: "enTestPaper",
            meta: {
                parent:{
					path:'/teacheManage/enTestPaper',
					title:'试卷管理',
					mosttitle:'试卷列表'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:true,title:'试卷列表',index:2
            },
            component: () => import("@/weteacheManage/enTestPaper/index")  
		},{
			path: "/teacheManage/enScoreAnalysis",
			name: "enScoreAnalysis",
			meta: {
				parent:{
					path:'/teacheManage/enTestPaper',
					title:'试卷管理',
					mosttitle:'统计分析',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'统计分析',index:2
			},
			component: () => import("@/weteacheManage/enTestPaper/enScoreAnalysis/index.vue")  
		},{
			path: "/teacheManage/enExamLog",
			name: "enExamLog",
			meta: {
				parent:{
					path:'/teacheManage/enTestPaper',
					title:'试卷管理',
					mosttitle:'考试记录',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'考试记录',index:2
			},
			component: () => import("@/weteacheManage/enTestPaper/enScoreAnalysis/enExamLog.vue")  
		},
		{
			path: "/teacheManage/enMoniToring",
			name: "enMoniToring",
			meta: {
				parent:{
					path:'/teacheManage/enTestPaper',
					title:'试卷管理',
					mosttitle:'考试监控',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'考试监控',index:2
			},
			component: () => import("@/weteacheManage/enTestPaper/enMoniToring/index.vue")  
		},
		{
			path: "/teacheManage/enGradingPaper",
			name: "enGradingPaper",
			meta: {
				parent:{
					path:'/teacheManage/enTestPaper',
					title:'试卷管理',
					mosttitle:'考试监控',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'批卷',index:2
			},
			component: () => import("@/weteacheManage/enTestPaper/enMoniToring/enGradingPaper.vue")  
		},
		{
			path: "/teacheManage/previewExam",
			name: "previewExam",
			meta: {
				parent:{
					path:'/teacheManage/enTestPaper',
					title:'试卷管理',
					mosttitle:'预览考试',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'预览考试',index:2
			},
			component: () => import("@/weteacheManage/enTestPaper/previewExam/index.vue")  
		},{
			path: "/teacheManage/enPrintingPaper",
			name: "enPrintingPaper",
			meta: {
				parent:{
					path:'/teacheManage/enTestPaper',
					title:'试卷管理',
					mosttitle:'打印试卷',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'打印试卷',index:2
			},
			component: () => import("@/weteacheManage/enTestPaper/enPrintingPaper/index.vue")
		},{
			path: "/teacheManage/enExportWord",
			name: "enExportWord",
			meta: {
				parent:{
					path:'/teacheManage/enTestPaper',
					title:'试卷管理',
					mosttitle:'打印试卷',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'打印试卷',index:2
			},
			component: () => import("@/weteacheManage/enTestPaper/enExportWord/index.vue")
		},
		{
			path: "/teacheManage/addEnTestPaper",
			name: "addEnTestPaper",
			meta: {
				parent:{
					path:'/teacheManage/enTestPaper',
					title:'试卷管理',
					mosttitle:'添加试题',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'添加试题',index:2
			},
			component: () => import("@/weteacheManage/enTestPaper/addEnTestPaper/index.vue")  
		},{
			path: "/teacheManage/twoEnIndex",
			name: "twoEnIndex",
			meta: {
				parent:{
					path:'/teacheManage/enTestPaper',
					title:'试卷管理',
					mosttitle:'添加试题',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'添加试题',index:2
			},
			component: () => import("@/weteacheManage/enTestPaper/addEnTestPaper/twoEnIndex.vue")  
		},{
			path: "/teacheManage/threeEnindex",
			name: "threeEnindex",
			meta: {
				parent:{
					path:'/teacheManage/enTestPaper',
					title:'试卷管理',
					mosttitle:'添加试题',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'添加试题',index:2
			},
			component: () => import("@/weteacheManage/enTestPaper/addEnTestPaper/threeEnindex.vue")  
		},
		{
            path: "/teacheManage/enTestPaperClass",
            name: "enTestPaperClass",
            meta: {
                parent:{
					path:'/teacheManage/questionClass',
					title:'试卷管理',
					mosttitle:'试卷分类'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'试卷分类',index:2
            },
            component: () => import("@/weteacheManage/enTestPaperClass/index")  
		},
		{
            path: "/teacheManage/questionClass",
            name: "questionClass",
            meta: {
                parent:{
					path:'/teacheManage/questionClass',
					title:'题库管理',
					mosttitle:'题目分类'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:true,title:'题目分类',index:3
            },
            component: () => import("@/weteacheManage/questionClass/index")  
        },{
            path: "/teacheManage/questionList",
            name: "questionList",
            meta: {
                parent:{
					path:'/teacheManage/questionList',
					title:'题库管理',
					mosttitle:'题目列表'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'题目列表',index:3
            },
            component: () => import("@/weteacheManage/questionList/index")  
        },{
			path: "/teacheManage/addQuestion",
			name: "addQuestion",
			meta: {
				parent:{
					path:'/teacheManage/questionList',
					title:'题库管理',
					mosttitle:'添加试题',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'添加试题',index:3
			},
			component: () => import("@/weteacheManage/questionList/addQuestion/index")  
		},{
			path: "/teacheManage/questionRepeaTopic",
			name: "questionRepeaTopic",
			meta: {
				parent:{
					path:'/teacheManage/questionList',
					title:'题库管理',
					mosttitle:'题库查重',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'题库查重',index:3
			},
			component: () => import("@/weteacheManage/questionList/questionRepeaTopic/index")  
		},{
			path: "/teacheManage/previewQuestion",
			name: "previewQuestion",
			meta: {
				parent:{
					path:'/teacheManage/questionList',
					title:'题库管理',
					mosttitle:'预览试题',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'预览试题',index:3
			},
			component: () => import("@/weteacheManage/questionList/previewQuestion/index")  
		},{
			path: "/teacheManage/questionCount",
			name: "questionCount",
			meta: {
				parent:{
					path:'/teacheManage/questionList',
					title:'题库管理',
					mosttitle:'统计试题',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'统计试题',index:3
			},
			component: () => import("@/weteacheManage/questionList/questionCount/index")  
		},
		{
            path: "/teacheManage/questionImport",
            name: "questionImport",
            meta: {
                parent:{
					path:'/teacheManage/questionImport',
					title:'题库管理',
					mosttitle:'批量导入'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'批量导入',index:3
            },
            component: () => import("@/weteacheManage/questionList/questionImport/index")  
        },{
			path: "/questionTwoSteps",
			name: "questionTwoSteps",
			meta: {
				parent:{
					path:'/teacheManage/questionImport',
					title:'题库管理',
					mosttitle:'批量导入',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'批量导入',index:3
			},
			component: () => import("@/weteacheManage/questionList/questionImport/questionTwoSteps")  
		},
		{
            path: "/teacheManage/enSimulationPaper",
            name: "enSimulationPaper",
            meta: {
                parent:{
					path:'/teacheManage/enSimulationPaper',
					title:'仿真试卷管理',
					mosttitle:'仿真试卷列表'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:true,title:'仿真试卷列表',index:4
            },
            component: () => import("@/weteacheManage/enSimulationPaper/index")  
		},{
            path: "/teacheManage/addEnRaso",
            name: "addEnRaso",
            meta: {
                parent:{
					path:'/teacheManage/addEnRaso',
					title:'仿真试卷管理',
					mosttitle:'仿真试卷列表'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'添加仿真试卷',index:4
            },
            component: () => import("@/weteacheManage/enSimulationPaper/addEnRaso/index")  
		},{
            path: "/teacheManage/twoEnRaso",
            name: "twoEnRaso",
            meta: {
                parent:{
					path:'/teacheManage/twoEnRaso',
					title:'仿真试卷管理',
					mosttitle:'仿真试卷列表'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'添加仿真试卷',index:4
            },
            component: () => import("@/weteacheManage/enSimulationPaper/addEnRaso/twoIndex")  
		},{
            path: "/teacheManage/enImportStep",
            name: "enImportStep",
            meta: {
                parent:{
					path:'/teacheManage/enImportStep',
					title:'仿真试卷管理',
					mosttitle:'仿真试卷列表'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'导入过程步骤',index:4
            },
            component: () => import("@/weteacheManage/enSimulationPaper/enImportStep/index")  
		},
		{
            path: "/teacheManage/endEnRaso",
            name: "endEnRaso",
            meta: {
                parent:{
					path:'/teacheManage/endEnRaso',
					title:'仿真试卷管理',
					mosttitle:'仿真试卷列表'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'添加仿真试卷',index:4
            },
            component: () => import("@/weteacheManage/enSimulationPaper/addEnRaso/endIndex")  
		},
		{
            path: "/teacheManage/enRasoAnalysis",
            name: "enRasoAnalysis",
            meta: {
                parent:{
					path:'/teacheManage/enRasoAnalysis',
					title:'仿真试卷管理',
					mosttitle:'仿真试卷列表'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'仿真试卷统计分析',index:4
            },
            component: () => import("@/weteacheManage/enSimulationPaper/enRasoAnalysis/index")  
		},
		{
            path: "/teacheManage/enRasoExamLog",
            name: "enRasoExamLog",
            meta: {
                parent:{
					path:'/teacheManage/enRasoExamLog',
					title:'仿真试卷管理',
					mosttitle:'仿真试卷列表'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'考试记录',index:4
            },
            component: () => import("@/weteacheManage/enSimulationPaper/enRasoAnalysis/rasoExamLog")  
		},
		{
            path: "/teacheManage/enRasoMoniToring",
            name: "enRasoMoniToring",
            meta: {
                parent:{
					path:'/teacheManage/enRasoMoniToring',
					title:'仿真试卷管理',
					mosttitle:'仿真试卷列表'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:false,title:'考试监控',index:4
            },
            component: () => import("@/weteacheManage/enSimulationPaper/enRasoMoniToring/index")  
		}
    ]
}